const quoteURL = 'https://api.api-ninjas.com/v1/quotes?category=love';

export default quoteURL;
